export const dateTimeFormat = 'DD/MM/YYYY HH:mm'
